import { Financiera } from "./../../catalagos/entidades/financiera";
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from "@angular/common/http";
import { Injectable, Output, EventEmitter } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs";
import { environment } from "../../../environments/environment";
import { UrlConstantes } from "../../utilerias/constantes/urlconstantes";
import { ConsultaList } from "../model/core/ConsultaList.model";
import { Area } from "../model/empleado/area.model";
import { Puesto } from "../model/empleado/puesto.model";
import { Fondo } from "../../catalagos/entidades/fondo";
import { DestinoCredito } from "../model/catalogos/destinoCredito.model";
import { Identificacion } from "../model/catalogos/tipo-identificacion";
import { Sucursal } from "../model/general/sucursal.model";
import { map } from "rxjs/operators";
import { Direccion } from "src/app/direccion/direccion.model";
import { UsuarioDto } from "../model/security/usuarioDto.model";
import { BusquedaProducto } from "../../catalagos/entidades/busqueda-producto";
import { TipoDocumentos } from "../model/catalogos/catalogodocumentos";
import { TipoGarantia } from "../model/catalogos/tipo-garantia";
import { TipoPersona } from "../model/persona/tipo-persona";
import { Periodicidad } from "src/app/catalagos/entidades/periodicidad";
import { Plazo } from "src/app/catalagos/entidades/plazo";
import { DocumentoCatalogo } from "src/app/catalagos/entidades/documento.catalogo";
import { ProductoCredito } from "src/app/creditos/modelos/producto-credito";
import { CreditoDocumentos } from "src/app/creditos/modelos/credito-documentos";
import { ProyeccionInversionDto } from "src/app/inversion/proyeccion/proyeccion.inversion.dto";
import { Aval } from "src/app/creditos/modelos/aval";
import { Coacreditado } from "src/app/creditos/modelos/coacreditado";
import { Inversion } from "src/app/inversion/modelos/inversion";
import { DocumentoInversion } from "src/app/inversion/modelos/documento-inversion";
import { Persona } from "../model/persona/persona";
import { PldFisico } from "../model/persona/pld-fisico";
import { CatalogoDocumentosPersona } from "src/app/catalagos/entidades/catalogoDocumentoPersona";
import { RegistroDocumentosPersona } from "src/app/catalagos/entidades/registroDocumentoPersona";
import { PagareAmortizacion } from "src/app/creditos/modelos/pagare-amortizacion";
import { ConsultaCoacreditados } from "src/app/creditos/modelos/consulta-coacreditados";
import { ConsultaAvales } from "src/app/creditos/modelos/consulta-avales";
import { ConsultaGarantias } from "src/app/creditos/modelos/consulta-garantias";
import { ConsultaDocumentos } from "src/app/creditos/modelos/consulta-documentos";

const API_URL = environment.apiUrl;
const API_URL_PUBLIC = environment.apiUrlPublic;

@Injectable({
  providedIn: "root",
})
export class GenericoService {
  constructor(private http: HttpClient) {}

  private idinmueble = new BehaviorSubject<number>(0);
  cast = this.idinmueble.asObservable();

  private estatus = new BehaviorSubject<boolean>(false);
  public isOpen = this.estatus.asObservable();

  /**
   * Método en cargado de crear la ruta completa para las peticiones
   * @param url // url del recurso al que se desea acceder
   */
  protected obtenerRutaCompleta = function (url: string) {
    return API_URL + url;
  };

  private crearAuthToken() {
    const token = localStorage.getItem("tkCocred");
    return new HttpHeaders({
      "Content-Type": "application/json",
      "X-Auth-Token": token,
    });
  }

  private crearTokenHeader() {
    return new HttpHeaders({
      "Content-Type": "application/pdf",
      "X-Auth-Token": localStorage.getItem("tkCocred"),
      "X-Requested-With": "XMLHttpRequest",
    });
  }

  /**
   * Obtiene el elemento correspondiente al parametro indicado
   * @param url
   * @param elemento
   */

  public ejecutaServicioSinObtenerElemento(url: string, elemento: any) {
    return this.http.post<any>(API_URL_PUBLIC + url, elemento);
  }

  /**
   * Obtiene el elemento correspondiente al parametro indicado
   * @param url
   * @param elemento
   */
  public ejecutaServicioSinObtenerElemento2(url: string, elemento: any) {
    return this.http.post<any>(API_URL_PUBLIC + url, elemento, {
      headers: this.crearAuthToken(),
    });
  }

  consultarAreaPaginacion(req: ConsultaList<Area>) {
    return this.http.post<ConsultaList<Area>>(
      UrlConstantes.consultaAreaPaginacion,
      req,
      { headers: this.crearAuthToken() }
    );
  }

  consultarPuestoPorAreaPaginacion(req: ConsultaList<Puesto>) {
    return this.http.post<ConsultaList<Puesto>>(
      UrlConstantes.consultaPuestoPorAreaPaginacion,
      req,
      { headers: this.crearAuthToken() }
    );
  }

  guardarArea(area: Area) {
    return this.http.post<any>(UrlConstantes.guardarArea, area, {
      headers: this.crearAuthToken(),
    });
  }

  /**
   * Realiza una petición GET enviando los parámetros de paginación y búsqueda
   * @param  url - Url genérico del recurso
   * @return Genérico
   */
  public obtenerTablaPorPagina(
    url: string,
    page: number,
    size: number,
    sort: string,
    search: any
  ): Observable<any> {
    const httpParams = new HttpParams()
      .set("page", String(page))
      .set("size", String(size))
      .set("sort", String(sort))
      .set("search", String(search));
    return this.http.get<any>(this.obtenerRutaCompleta(url), {
      params: httpParams,
      responseType: "json",
    });
  }

  /**
   * Método que obtiene la colección sin filtros
   * @param url // Ruta del elemento
   */
  public obtenerColeccion(url: string) {
    return this.http.get<any>(this.obtenerRutaCompleta(url), {
      headers: this.crearAuthToken(),
    });
  }

  /**
   * Actualiza un registro a través de la URL genérica
   * @param url - Url genérica del recurso
   * @param objeto - Registro a actualizar
   */
  public actualizarRegistro(url: string, objeto: any): Observable<any> {
    return this.http.put<any>(this.obtenerRutaCompleta(url), objeto, {
      headers: this.crearAuthToken(),
    });
  }
  public consultaGenericaPost(url: string, objeto: any) {
    return this.http.post<any>(this.obtenerRutaCompleta(url), objeto, {
      headers: this.crearAuthToken(),
    });
  }

  public consultaGenericaGetById(url: string, objeto: any, id: any) {
    return this.http.get<any>(this.obtenerRutaCompleta(url) + "/" + id, {
      headers: this.crearAuthToken(),
    });
  }

  public notificacionWhatsapp(url: string, objeto: any) {
    return this.http.post<any>(this.obtenerRutaCompleta(url), objeto);
  }

  consultarFodoPaginacion(req: ConsultaList<Fondo>) {
    return this.http.post<ConsultaList<Fondo>>(
      UrlConstantes.consultaFondoPaginacion,
      req,
      { headers: this.crearAuthToken() }
    );
  }

  guardarFondo(fondo: Fondo) {
    return this.http.post<any>(UrlConstantes.guardarFondo, fondo, {
      headers: this.crearAuthToken(),
    });
  }

  consultarFinanciera() {
    return this.http.post<ConsultaList<Financiera>>(
      UrlConstantes.consultaFinanciera,
      { headers: this.crearAuthToken() }
    );
  }

  consultaDestinosCreditoPaginacion(req: ConsultaList<DestinoCredito>) {
    return this.http.post<ConsultaList<DestinoCredito>>(
      UrlConstantes.consultarDestinoCreditoPaginacion,
      req,
      { headers: this.crearAuthToken() }
    );
  }

  consultaDestinoCreditosTodos() {
    return this.http.get<any>(UrlConstantes.consultarDestinoCreditoTodos, {
      headers: this.crearAuthToken(),
    });
  }

  guardarActualizarDestinoCredito(destino: DestinoCredito) {
    return this.http.post<any>(UrlConstantes.guardaActualizaDestino, destino, {
      headers: this.crearAuthToken(),
    });
  }
  consultarSucursales(req: ConsultaList<Sucursal>) {
    return this.http.post<ConsultaList<Sucursal>>(
      UrlConstantes.ConsultarSucursalesPaginacion,
      req,
      { headers: this.crearAuthToken() }
    );
  }
  guardaActualizaSucursal(sucursal: Sucursal) {
    return this.http.post<any>(
      UrlConstantes.guardaActualizaSucursal,
      sucursal,
      { headers: this.crearAuthToken() }
    );
  }
  consultaExistenciaMatriz() {
    return this.http.post<Sucursal[]>(UrlConstantes.consultaExistenciaMatriz, {
      headers: this.crearAuthToken(),
    });
  }

  iniciarCargaDeArchivo(data: FormData) {
    return this.http
      .post<any>(UrlConstantes.iniciaCargaInicial, data, {
        reportProgress: true,
        observe: "events",
      })
      .pipe(
        map((event) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              const progress = Math.round((100 * event.loaded) / event.total);
              return { status: "progress", message: progress };

            case HttpEventType.Response:
              return event.body;
            default:
              return `Unhandled event: ${event.type}`;
          }
        })
      );
  }
  public obtenerElementoPorCampo2(elemento): Observable<any> {
    const httpParams = new HttpParams().set("elemento", elemento);
    return this.http.get<any>(this.obtenerRutaCompleta("url"), {
      params: httpParams,
      responseType: "json",
    });
  }

  consultaDiferentesEstados() {
    return this.http.post<Direccion[]>(
      UrlConstantes.consultaDistEstados,
      null,
      { headers: this.crearAuthToken() }
    );
  }

  public consultaPorCodigoPostal(codigo: string): Observable<any> {
    const httpParams = new HttpParams().set("codigoPostal", "" + codigo);
    return this.http.get<any>(UrlConstantes.consultaPorCodigoPostal, {
      params: httpParams,
      headers: this.crearAuthToken(),
      responseType: "json",
    });
  }

  public consultaPorEstado(estado: string, codigo: string): Observable<any> {
    const httpParams = new HttpParams()
      .set("codigoPostal", String(codigo))
      .set("estado", String(estado));
    return this.http.get<any>(UrlConstantes.consultaPorEstado, {
      params: httpParams,
      headers: this.crearAuthToken(),
      responseType: "json",
    });
  }

  public consultaPorMunicipioAndEstado(
    municipio: string,
    estado: string,
    codigo: string
  ): Observable<any> {
    const httpParams = new HttpParams()
      .set("codigoPostal", String(codigo))
      .set("municipio", String(municipio))
      .set("estado", String(estado));
    return this.http.get<any>(UrlConstantes.consultaPorEstadoYMunicipio, {
      params: httpParams,
      headers: this.crearAuthToken(),
      responseType: "json",
    });
  }

  public consultaPorCiudadAndMunicipioAndEstado(
    ciudad: string,
    municipio: string,
    estado: string,
    codigo: string
  ): Observable<any> {
    const httpParams = new HttpParams()
      .set("codigoPostal", String(codigo))
      .set("ciudad", String(ciudad))
      .set("municipio", String(municipio))
      .set("estado", String(estado));
    return this.http.get<any>(UrlConstantes.ConsultaPorEstadoMunicipioCiudad, {
      params: httpParams,
      headers: this.crearAuthToken(),
      responseType: "json",
    });
  }
  public consultaPoTipoAsentamientoCiudadAndMunicipioAndEstado(
    tipoAsen: string,
    ciudad: string,
    municipio: string,
    estado: string,
    codigo: string
  ): Observable<any> {
    const httpParams = new HttpParams()
      .set("codigoPostal", String(codigo))
      .set("tipoAsen", String(tipoAsen))
      .set("ciudad", String(ciudad))
      .set("municipio", String(municipio))
      .set("estado", String(estado));
    return this.http.get<any>(
      UrlConstantes.ConsultaPorEstadoMunicipioCiudadTipoAsent,
      {
        params: httpParams,
        headers: this.crearAuthToken(),
        responseType: "json",
      }
    );
  }
  consultaDiferentesTiposDeAsentamiento() {
    return this.http.post<Direccion[]>(
      UrlConstantes.consultaDistTiposAsentamiento,
      null,
      { headers: this.crearAuthToken() }
    );
  }

  consultarIdentificacionPaginacion(bean: ConsultaList<Identificacion>) {
    return this.http.post<ConsultaList<Identificacion>>(
      UrlConstantes.consultaIdentificacionPaginacion,
      bean,
      { headers: this.crearAuthToken() }
    );
  }

  guardarIdentificacion(identificacion: Identificacion) {
    return this.http.post<any>(
      UrlConstantes.guardarIdentificacion,
      identificacion,
      { headers: this.crearAuthToken() }
    );
  }

  ConsulXUpdateIdentificacion(
    beanidentificacion: Identificacion
  ): Observable<any> {
    return this.http.post<ConsultaList<Identificacion>>(
      UrlConstantes.ConsulXUpdateIdentificacion,
      beanidentificacion,
      { headers: this.crearAuthToken() }
    );
  }

  consultaUsuario(): Observable<ConsultaList<UsuarioDto>> {
    return this.http.post<ConsultaList<UsuarioDto>>(
      UrlConstantes.consultarUsuario,
      "",
      { headers: this.crearAuthToken() }
    );
  }

  guardaActualizaUsuario(bean: UsuarioDto) {
    return this.http.post<any>(UrlConstantes.guardaActualizaUsuario, bean, {
      headers: this.crearAuthToken(),
    });
  }

  consultarTallerPaginacion(bean: ConsultaList<BusquedaProducto>) {
    return this.http.post<ConsultaList<BusquedaProducto>>(
      UrlConstantes.consultaTallerPaginacion,
      bean,
      { headers: this.crearAuthToken() }
    );
  }
  consultarDocumentacionPaginacion(bean: ConsultaList<TipoDocumentos>) {
    return this.http.post<ConsultaList<TipoDocumentos>>(
      UrlConstantes.consultarDocumentacionPaginacion,
      bean,
      { headers: this.crearAuthToken() }
    );
  }
  consultaGarantia(bean: ConsultaList<TipoGarantia>) {
    return this.http.post<ConsultaList<TipoGarantia>>(
      UrlConstantes.consultaGarantia,
      bean,
      { headers: this.crearAuthToken() }
    );
  }
  consultaCreditos(bean: ConsultaList<TipoGarantia>) {
    return this.http.post<ConsultaList<TipoGarantia>>(
      UrlConstantes.consultaCredito,
      bean,
      { headers: this.crearAuthToken() }
    );
  }
  guardaActualizaDocumento(documento: TipoDocumentos) {
    return this.http.post<any>(
      UrlConstantes.guardaActualizaDocumento,
      documento,
      { headers: this.crearAuthToken() }
    );
  }
  ConsulXUpdateDocumento(tipoDocumentos: TipoDocumentos): Observable<any> {
    return this.http.post<ConsultaList<TipoDocumentos>>(
      UrlConstantes.ConsulXUpdateDocumento,
      tipoDocumentos,
      { headers: this.crearAuthToken() }
    );
  }

  consultarPersonasPaginacion(bean: ConsultaList<TipoPersona>) {
    return this.http.post<ConsultaList<TipoPersona>>(
      UrlConstantes.consultarPersonasPaginacion,
      bean,
      { headers: this.crearAuthToken() }
    );
  }
  guardaActualizaPersona(persona: TipoPersona) {
    return this.http.post<any>(UrlConstantes.guardaActualizaPersona, persona, {
      headers: this.crearAuthToken(),
    });
  }
  consultarPeriodicidadPaginacion(bean: ConsultaList<Periodicidad>) {
    return this.http.post<ConsultaList<Periodicidad>>(
      UrlConstantes.consultarPeriodicidadPaginacion,
      bean,
      { headers: this.crearAuthToken() }
    );
  }
  guardaPeriodicidad(periodicidad: Periodicidad) {
    return this.http.post<any>(UrlConstantes.guardaPeriodicidad, periodicidad, {
      headers: this.crearAuthToken(),
    });
  }

  consultpersonfoto() {
    return this.http.get(UrlConstantes.fotoPersona, {
      headers: this.crearAuthToken(),
      responseType: "arraybuffer",
    });
  }

  uploadPersonFoto(formData) {
    console.log(formData);
    return this.http
      .post(UrlConstantes.uploadFotoPersona, formData, {
        reportProgress: true,
        observe: "events",
        headers: new HttpHeaders({
          "X-Auth-Token": localStorage.getItem("tkCocred"),
        }),
      })
      .pipe(
        map((event) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              const progress = Math.round((100 * event.loaded) / event.total);
              return { status: "progress", message: progress };

            case HttpEventType.Response:
              return event.body;
            default:
              return `Unhandled event: ${event.type}`;
          }
        })
      );
  }

  validarDuplicado(bean: Plazo) {
    return this.http.post<any>(UrlConstantes.validarDuplicado, bean, {
      headers: this.crearAuthToken(),
    });
  }
  validarDuplicadoGarantia(bean: TipoGarantia) {
    return this.http.post<any>(UrlConstantes.validarDuplicadoGarantia, bean, {
      headers: this.crearAuthToken(),
    });
  }

  consultaTipoGarantiasActivos(): Observable<any> {
    return this.http.get<any>(UrlConstantes.consultaTipoGarantiaActivos, {
      headers: this.crearAuthToken(),
    });
  }

  addupdate(plazo: Plazo) {
    return this.http.post<any>(UrlConstantes.guardaActualizaPlazo, plazo, {
      headers: this.crearAuthToken(),
    });
  }

  consultaDocumentos(idTipoCredito: number, idCredito: number) {
    let consulta: ConsultaDocumentos = new ConsultaDocumentos(
      idTipoCredito,
      idCredito
    );
    return this.http.post<ConsultaList<DocumentoCatalogo>>(
      UrlConstantes.consultaDocumentoCredito,
      consulta,
      { headers: this.crearAuthToken() }
    );
  }

  consultaGarantias(idGarantia: number, idCredito: number) {
    let consultaG: ConsultaGarantias = new ConsultaGarantias(
      idGarantia,
      idCredito
    );
    return this.http.post<ConsultaList<DocumentoCatalogo>>(
      UrlConstantes.consultaGarantias,
      consultaG,
      { headers: this.crearAuthToken() }
    );
  }

  consultaAvales(idCredito: number) {
    let consultC: ConsultaAvales = new ConsultaAvales(idCredito);
    return this.http.post<ConsultaList<Aval>>(
      UrlConstantes.consultaAvales,
      consultC,
      { headers: this.crearAuthToken() }
    );
  }

  guardaRegistroDocumentos(documentoRegistro: ProductoCredito) {
    return this.http.post<any>(
      UrlConstantes.guardaRegistroDocumentos,
      documentoRegistro,
      { headers: this.crearAuthToken() }
    );
  }

  public ejecutaServicioAltaDocumentoCreditoGarantia(
    url: string,
    elemento: any
  ) {
    return this.http.post<any>(url, elemento, {
      headers: this.crearAuthToken(),
    });
  }

  public visualizaEstadoPersona(idCred: number, idPersona) {
    return this.VisualizaArchivo(
      environment.apiUrl + "documentos/visualizarEstadosDeCuentaPersona",
      idPersona,
      "" + idCred,
      0
    );
  }

  public visualizaSolictudCredito(idCred: number, idPersona) {
    return this.VisualizaArchivo(
      environment.apiUrl + "documentos/visualizarSolicitudCredito",
      idPersona,
      "" + idCred,
      0
    );
  }

  public VisualizaArchivo(
    url: string,
    idDoc: string,
    idCred: string,
    pref?: number
  ) {
    let credDoc: CreditoDocumentos = new CreditoDocumentos(pref);
    credDoc.idDocumento = Number(idDoc);
    credDoc.idCredito = Number(idCred);
    return this.http.post(url, credDoc, {
      headers: this.crearAuthToken(),
      responseType: "arraybuffer",
    });
  }

  public VisualizaArchivoPrefijo(
    url: string,
    idDoc: string,
    idCred: string,
    idPersona: any,
    pref?: number
  ) {
    let credDoc: CreditoDocumentos = new CreditoDocumentos(pref);
    credDoc.idDocumento = Number(idDoc);
    credDoc.idCredito = Number(idCred);
    credDoc.prefijo = credDoc.prefijo + idPersona;
    return this.http.post(url, credDoc, {
      headers: this.crearAuthToken(),
      responseType: "arraybuffer",
    });
  }

  consultaCorreoJuridico(area: CreditoDocumentos) {
    return this.http.post<any>(UrlConstantes.consultaCorreoJuridico, area, {
      headers: this.crearAuthToken(),
    });
  }

  consultaInversion(idArea: number) {
    return this.http.post<ConsultaList<ProyeccionInversionDto>>(
      UrlConstantes.consultaInversiones,
      idArea,
      { headers: this.crearAuthToken() }
    );
  }

  guardaProyeccion(documentoProyeccion: ProyeccionInversionDto) {
    return this.http.post<any>(
      UrlConstantes.guardaProyeccion,
      documentoProyeccion,
      { headers: this.crearAuthToken() }
    );
  }

  guardaInversion(inversion: Inversion) {
    console.debug(UrlConstantes.guardaInversion);
    return this.http.post<any>(UrlConstantes.guardaInversion, inversion, {
      headers: this.crearAuthToken(),
    });
  }

  obtenerInversionPorID(id: number) {
    return this.http.post<any>(UrlConstantes.obtenerInversionPorID, id, {
      headers: this.crearAuthToken(),
    });
  }

  consultaIdInversion() {
    return this.http.post<any>(UrlConstantes.consultaidInversion, {
      headers: this.crearAuthToken(),
    });
  }

  consultaCatDocumentoInversion() {
    return this.http.get<any>(UrlConstantes.documentoInversion, {
      headers: this.crearAuthToken(),
    });
  }

  guardaDocumentoInversion(documentoInversion: DocumentoInversion) {
    return this.http.post<any>(
      UrlConstantes.guardaDocumentoInversion,
      documentoInversion
    );
  }

  actualizarRegistroDocumentos(documento: DocumentoCatalogo) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "X-Auth-Token": localStorage.getItem("tkCocred"),
    });
    return this.http.post<DocumentoCatalogo>(
      API_URL + "documentos/actualizarRegistroDocumentos",
      documento,
      { headers: this.crearAuthToken() }
    );
  }

  

  escanearDocumentoLocal(duplex: boolean, urlEscaner: string) {
    return this.http.post(
      urlEscaner,
      { duplex: duplex }, // 🔹 envía un objeto JSON
      { headers: { "Content-Type": "application/json" } } // 🔹 muy importante
    );
  }

  consultaDocumentosContrato() {
    return this.http.post<ConsultaList<TipoDocumentos>>(
      API_URL + "documentos/consultaDocumentosContrato",
      "",
      { headers: this.crearAuthToken() }
    );
  }

  public generarContrato(url: string, param: any): Observable<any> {
    const httpParams = new HttpParams().set("param", String(param));

    return this.http.get(url, {
      params: httpParams,
      headers: this.crearTokenHeader(),
      responseType: "arraybuffer",
    });
  }

  actualizarTablaAmortizacion(pagareAmortizacion: PagareAmortizacion) {
    return this.http.post<PagareAmortizacion[]>(
      API_URL + "tablaAmortizacionService/actualizarTablaAmortizacion.do",
      pagareAmortizacion,
      { headers: this.crearAuthToken() }
    );
  }

  public buscarDocumentoDescripcion(doc: DocumentoCatalogo): Observable<any> {
    return this.http.post<any>(
      UrlConstantes.CONSULTAR_DOCUMENTO_DESCRIPCION,
      doc,
      { headers: this.crearAuthToken() }
    );
  }

  public generarPagare(url: string, param: any): Observable<any> {
    const httpParams = new HttpParams().set("param", String(param));

    return this.http.get(url, {
      params: httpParams,
      headers: this.crearTokenHeader(),
      responseType: "arraybuffer",
    });
  }

  public generarRecibo(url: string, param: any): Observable<any> {
    const httpParams = new HttpParams().set("param", String(param));

    return this.http.get(url, {
      params: httpParams,
      headers: this.crearTokenHeader(),
      responseType: "arraybuffer",
    });
  }

  public generarPldFisico(url: string, param: any): Observable<any> {
    const httpParams = new HttpParams().set("param", String(param));

    return this.http.get(url, {
      params: httpParams,
      headers: this.crearTokenHeader(),
      responseType: "arraybuffer",
    });
  }
  public generarPldMoral(url: string, param: any): Observable<any> {
    const httpParams = new HttpParams().set("param", String(param));

    return this.http.get(url, {
      params: httpParams,
      headers: this.crearTokenHeader(),
      responseType: "arraybuffer",
    });
  }

  public generarGarantiasMuebles(url: string, param: any): Observable<any> {
    const httpParams = new HttpParams().set("param", String(param));

    return this.http.get(url, {
      params: httpParams,
      headers: this.crearTokenHeader(),
      responseType: "arraybuffer",
    });
  }

  public generarGarantiasInMuebles(url: string, param: any): Observable<any> {
    const httpParams = new HttpParams().set("param", String(param));

    return this.http.get(url, {
      params: httpParams,
      headers: this.crearTokenHeader(),
      responseType: "arraybuffer",
    });
  }

  public generarReporteFondeo(url: string, param: any): Observable<any> {
    const httpParams = new HttpParams().set("param", String(param));

    return this.http.get(url, {
      params: httpParams,
      headers: this.crearTokenHeader(),
      responseType: "arraybuffer",
    });
  }

  obtenerPldMoral(idPersona: number) {
    return this.http.post<any>(UrlConstantes.obtenerPldMoral, idPersona, {
      headers: this.crearAuthToken(),
    });
  }

  obtenerPldFisico(idPersona: number) {
    return this.http.post<any>(UrlConstantes.obtenerPldFisico, idPersona, {
      headers: this.crearAuthToken(),
    });
  }

  actualizaPldFisico(pld: PldFisico) {
    return this.http.post<any>(UrlConstantes.actualizaFisico, pld, {
      headers: this.crearAuthToken(),
    });
  }

  obtenerCuestionarioMuebles(idCredito: number) {
    return this.http.post<any>(
      UrlConstantes.obtenerCuestionarioMuebles,
      idCredito,
      { headers: this.crearAuthToken() }
    );
  }

  consultaInversiones() {
    return this.http.get<any>(UrlConstantes.CONSULTA_INVERSIONES, {
      headers: this.crearAuthToken(),
    });
  }

  consultaInversionesFiltro(inversion: ConsultaList<Inversion>) {
    return this.http.post<any>(
      UrlConstantes.CONSULTA_INVERSIONES_FILTRO,
      inversion
    );
  }

  guardarPersonaGarantias(persona: DocumentoCatalogo) {
    return this.http.post<any>(
      UrlConstantes.actualizacionPersonaGarantias,
      persona,
      { headers: this.crearAuthToken() }
    );
  }
  consultaPersonaGarantia(idGarantia: number) {
    return this.http.post<any>(
      UrlConstantes.consultaPersonaGarantia,
      idGarantia,
      { headers: this.crearAuthToken() }
    );
  }

  obtenerCuestionarioInmuebles(idCredito: number) {
    return this.http.post<any>(
      UrlConstantes.obtenerCuestionarioInmuebles,
      idCredito,
      { headers: this.crearAuthToken() }
    );
  }

  guardaActualizaDocumentoPersona(documento: CatalogoDocumentosPersona) {
    return this.http.post<any>(
      UrlConstantes.guardaActualizaCatalogoDocumentosPersona,
      documento,
      { headers: this.crearAuthToken() }
    );
  }
  consultarRegistroDocumentosPersona(persona: Persona) {
    return this.http.post<any>(
      UrlConstantes.consultaRegistroDocumentosPersona,
      persona,
      { headers: this.crearAuthToken() }
    );
  }

  public VisualizaArchivoPersona(url: string, d: RegistroDocumentosPersona) {
    return this.http.post(url, d, {
      headers: this.crearAuthToken(),
      responseType: "arraybuffer",
    });
  }

  guardar(objeto: any, url) {
    return this.http.post<any>(url, objeto, { headers: this.crearAuthToken() });
  }
}
